import { EvidenceItem } from "@/pages/ProductStructure/components/EvidenceCommentsDisplay";
import { MessageCircle, ArrowUp, Users } from "lucide-react";

const RedditCards = ({
  item,
  handleOpenCommentsModal,
}: {
  item: EvidenceItem;
  handleOpenCommentsModal: (item: EvidenceItem) => void;
}) => {
  return (
    <div className="max-w-4xl mx-auto">
      <div
        onClick={() => handleOpenCommentsModal(item)}
        className="group rounded-2xl p-6 bg-white border border-gray-100 hover:border-gray-200 cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-1"
      >
        {/* Header with subreddit badge */}
        <div className="flex items-center justify-between mb-3">
          <div
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border`}
          >
            <Users className="w-4 h-4 mr-1" />
            r/{item.subreddit}
          </div>
          <div className="flex items-center space-x-4 text-gray-500">
            <div className="flex items-center space-x-1">
              <ArrowUp className="w-4 h-4" />
              <span className="text-sm font-medium">
                {/* {formatScore(item?.total_score as number)} */}
                {item?.total_score}
              </span>
            </div>
          </div>
        </div>

        {/* Post title */}
        <h3 className="text-lg font-semibold text-gray-800 leading-relaxed mb-4 group-hover:text-gray-900 transition-colors">
          {item.post_title}
        </h3>

        {/* Footer with engagement metrics */}
        <div className="flex items-center justify-between pt-3 border-t border-gray-50">
          <div className="flex items-center space-x-1 text-gray-500">
            <MessageCircle className="w-4 h-4" />
            <span className="text-sm">
              {item.total_comments}{" "}
              {item.total_comments === 1 ? "comment" : "comments"}
            </span>
          </div>

          <div className="text-sm text-gray-400 group-hover:text-gray-500 transition-colors">
            Click to view discussion →
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedditCards;

export const RedditCardsSkeleton = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="rounded-2xl p-6 bg-white border border-gray-100">
        {/* Header with subreddit badge skeleton */}
        <div className="flex items-center justify-between mb-3">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200">
            <Users className="w-4 h-4 mr-1 text-gray-300" />
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="flex items-center space-x-4 text-gray-300">
            <div className="flex items-center space-x-1">
              <ArrowUp className="w-4 h-4" />
              <div className="h-4 w-8 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Post title skeleton */}
        <div className="mb-4 space-y-2">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-full"></div>
          <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4"></div>
        </div>

        {/* Footer skeleton */}
        <div className="flex items-center justify-between pt-3 border-t border-gray-50">
          <div className="flex items-center space-x-1 text-gray-300">
            <MessageCircle className="w-4 h-4" />
            <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
          </div>

          <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
